import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';
import Link from 'next/link';

type TextLinkProps = Pick<
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
  'href' | 'target' | 'rel' | 'children' | 'className'
> & { internalLink?: boolean; newTabIcon?: boolean; onClick?: () => void };

export const TextLink = (props: TextLinkProps) => {
  const Component: React.ElementType = props.internalLink ? Link : 'a';

  if (props.newTabIcon) {
    return (
      <span className="inline-flex items-center">
        <Component
          {...props}
          className="cursor-pointer bg-gradient-to-r from-sky-500 to-blue-600 bg-clip-text font-semibold text-transparent hover:from-sky-600 hover:to-blue-700"
        />
        <OpenInNewTab />
      </span>
    );
  }

  return (
    <Component
      {...props}
      className="cursor-pointer bg-gradient-to-r from-sky-500 to-blue-600 bg-clip-text font-semibold text-transparent hover:from-sky-600 hover:to-blue-700"
    />
  );
};

// not currently in use
export const TextLinkPlain = (props: TextLinkProps) => {
  return (
    <a {...props} className="cursor-pointer font-semibold text-gray-900 hover:text-gray-700" />
  );
};

export function OpenInNewTab() {
  return (
    <span className="ml-1.5">
      <ArrowTopRightOnSquareIcon className="h-4 w-4 text-gray-700" />
    </span>
  );
}
